module.exports = __webpack_public_path__ + "static/media/pizzaChampiñones.27023e0a.jpg";